/**
 * พิมพ์สัญญาซื้อรถ
 * **/

import React, { Component } from "react";
import axios from "axios";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import Loading from "../../Loading";
import { connect } from "react-redux";
import * as moment from "moment";
import { DateUtil } from "../../../utils/dateUtil";
import { APIURL } from "../../../config/config";
import ThaiBaht from "thai-baht-text";
import NumberFormat from "react-number-format";
import { AlertSuccess, AlertWarning } from "../../Alert/Alert";
import { NumberUtil } from "../../../utils/number-util";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DatePickerIcon from "../../DatePickerIcon";

import { format } from "date-fns";
import stringUtil from "../../../utils/stringUtil";
import {
  checkGroupPermission,
  getGroupPermission,
} from "../../../services/grouppermission";
import DatePickerBuddhist from "../../DatePickerBuddhist";
import ThaiDatePicker from "../../ThaiDatePicker";
import DatePickerInput from "../../DatePickerInput";

// import DatePicker from "react-date-picker";
// import th from 'date-fns/locale/th';
// registerLocale('th', th);
import { PDFUtil } from "../../../utils/pdfUtil";

pdfMake.vfs = pdfFonts;
pdfMake.fonts = PDFUtil.getCustomFonts();

const port = window.env.PORT;

class CarBuyContract2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      car: {},
      user: {},
      contract: null,
      contract_id: null,
      contract_no: "-",
      write_at: "",

      // วันที่ทำสัญญา
      startDateContract: new Date(),
      isOpenDateContract: false,
      contract_date_thai: null,
      contract_date: null,

      // ผู้ขาย
      seller_name: "",
      seller_age: "",
      seller_mobile: "",
      seller_address: "",
      seller_nationality: "",
      seller_by: "",

      // ผู้ซื้อ
      buyer_name: "",
      buyer_age: "",
      buyer_nationality: "",
      buyer_address: "",
      buyer_mobile: "",
      buyer_by: "",

      // ข้อมูลรถ
      car_name: "",
      car_license_plate: "",
      province_name: "",
      car_num_engines: "",
      car_number: "", // เลขตัวรถ
      car_year_name: "", // ปี
      car_color_name: "", // สี
      car_structure_name: "", // ลักษณะรถ
      car_brand_name: "", // ยี่ห้อ
      car_model_name: "", // รุ่นรถ
      car_gear_name: "", // เกียร์รถ

      // วันที่ชำระเงินที่เหลือ
      startPaidDueDate: new Date(),
      isOpenPaidDueDate: false,
      paid_due_date_thai: null,
      paid_due_date: null,

      // เงิน
      car_buy_cost: 0,
      pay_method: "", // โดยชำระเป็น
      cash_pledge: 0,
      remain_amount: 0,

      buy_sell_agreement1: "",
      buy_sell_agreement2: "",
      transfer_fee_by: "", //คนจ่ายค่าโอน

      // ลงชื่อ
      sign_seller: "",
      sign_buyer: "",
      sign_witness1: "",
      sign_witness2: "",

      card_type: "บัตรประชาชน",
      card_code: "",
      card_out_at: "",
      card_out_date: "",
      isExist: false,
      car_id: "",
      contract_note: "",
      menuID: [26],
      grouppermissions: [],
    };

    this.handleDateContract = this.handleDateContract.bind(this);
    this.loadCompanySetting = this.loadCompanySetting.bind(this);
    this.loadCarById = this.loadCarById.bind(this);
    // this.loadCarSellById = this.loadCarSellById.bind(this);
    this.loadCarBuyContract = this.loadCarBuyContract.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.loadDataCarSellPay = this.loadDataCarSellPay.bind(this);
    this.calOutstanding = this.calOutstanding.bind(this);
    this.handlePaidDueDate = this.handlePaidDueDate.bind(this);
    this.saveCarContract = this.saveCarContract.bind(this);
    this.printCarContract = this.printCarContract.bind(this);
    this.loadGroupPermission = this.loadGroupPermission.bind(this);
    this.manageAddEditButton = this.manageAddEditButton.bind(this);
    this.managePrintButton = this.managePrintButton.bind(this);
  }

  loadGroupPermission() {
    let type = this.state.user.type;
    let menuID = this.state.menuID;
    getGroupPermission(type, menuID).then((res) => {
      if (res.data.result === "success") {
        this.setState({
          grouppermissions: res.data.grouppermissions,
        });
      }
    });
  }

  manageAddEditButton() {
    if (
      this.state.contract_id === null &&
      checkGroupPermission(26, this.state.grouppermissions).created
    ) {
      return (
        <button
          type="button"
          className="btn btn-success btn-md mr-2"
          style={{ width: 120 }}
          onClick={() => this.saveCarContract("add")}
        >
          <i className="icon-check" />
          &nbsp;บันทึก
        </button>
      );
    } else if (
      this.state.contract_id !== null &&
      checkGroupPermission(26, this.state.grouppermissions).modified
    ) {
      return (
        <button
          type="button"
          className="btn btn-warning btn-md mr-2"
          style={{ width: 120 }}
          onClick={() => this.saveCarContract("edit")}
        >
          <i className="icon-pencil" />
          &nbsp;แก้ไข
        </button>
      );
    }
  }

  managePrintButton() {
    if (
      this.state.contract_id !== null &&
      checkGroupPermission(26, this.state.grouppermissions).printed
    ) {
      return (
        <button
          type="button"
          className="btn btn-primary btn-md mr-2"
          style={{ width: 120 }}
          onClick={() => this.printCarContract()}
        >
          <i className="icon-printer" /> พิมพ์
        </button>
      );
    }
    return null;
  }

  componentWillMount() {
    const queryString = require("query-string");
    let car = queryString.parse(this.props.location.search);
    let car_id = car.car_id;

    this.setState({
      user: JSON.parse(this.props.user),
      car_id: car_id,
    });
  }

  async componentDidMount() {
    this.mounted = true;

    this.loadGroupPermission();
    await this.loadCompanySetting();
    await this.loadCarBuyContract();
    await this.loadCarById();

    let contract_id = this.state.contract_id;

    if (contract_id === null) {
      let startDateContract = new Date();
      let contract_date = format(startDateContract, "yyyy-MM-dd");
      let contract_date_thai = DateUtil.convertLongDateThai(contract_date);

      this.setState({
        contract_date,
        contract_date_thai,
      });
    }
    // await this.loadCarContract(car_sell_id);
    // await this.loadCarSellById(car_sell_id);
  }

  componentWillUnmount() {
    this.mounted = false;
    // window.removeEventListener('resize', this.updateWindowDimensions);
    this.setState({
      user: JSON.parse(this.props.user),
    });
  }

  async loadCompanySetting() {
    await axios.get(APIURL + "/company_setting/1").then((res) => {
      let data = res.data;
      let company_setting = data.company_setting;
      if (company_setting !== null) {
        this.setState({
          company_setting: company_setting,
          buyer_name: company_setting.company_name,
          sign_buyer: company_setting.company_name,
          buyer_address: company_setting.company_address,
          buyer_mobile: company_setting.company_tel,
        });
      }
    });
  }

  async loadCarBuyContract() {
    const { car_id } = this.state;
    let url = APIURL + "/buy_contract/car/" + car_id;

    await axios
      .get(url)
      .then((res) => {
        let data = res.data;

        if (data.length > 0) {
          let contract = data[0];

          let contract_date =
            contract.contract_date !== null
              ? format(new Date(contract.contract_date), "yyyy-MM-dd")
              : "";
          let paid_due_date =
            contract.paid_due_date !== null
              ? format(new Date(contract.paid_due_date), "yyyy-MM-dd")
              : "";

          let contract_date_thai =
            contract.contract_date !== null
              ? DateUtil.convertLongDateThai(contract_date)
              : "";
          let paid_due_date_thai =
            contract.paid_due_date !== null
              ? DateUtil.convertLongDateThai(paid_due_date)
              : "";

          let province_name =
            contract.car_license_plate_new !== "" &&
            contract.car_license_plate_new !== contract.car_license_plate_old
              ? contract.province_name_new
              : contract.province_name_old;

          this.setState({
            contract: contract,
            contract_date_thai: contract_date_thai,
            paid_due_date_thai: paid_due_date_thai,
            contract_id: contract.contract_id,
            write_at: contract.write_at,
            contract_date: contract_date,
            contract_no: contract.contract_no,
            seller_name: contract.seller_name,
            seller_age: contract.seller_age,
            seller_mobile: contract.seller_mobile,
            seller_address: contract.seller_address,
            seller_nationality: contract.seller_nationality,
            seller_by: contract.seller_by,
            buyer_name: contract.buyer_name,
            buyer_age: contract.buyer_age,
            buyer_nationality: contract.buyer_nationality,
            buyer_address: contract.buyer_address,
            buyer_mobile: contract.buyer_mobile,
            buyer_by: contract.buyer_by,
            car_name: contract.car_name,
            car_license_plate: contract.car_license_plate,
            province_name: province_name,
            car_num_engines: contract.car_num_engines,
            car_number: contract.car_number,
            car_year_name: contract.car_year_name,
            car_color_name: contract.car_color_name,
            car_structure_name: contract.car_structure_name,
            car_brand_name: contract.car_brand_name,
            car_model_name: contract.car_model_name,
            car_gear_name: contract.car_gear_name,
            buy_sell_agreement1: contract.buy_sell_agreement1,
            buy_sell_agreement2: contract.buy_sell_agreement2,
            transfer_fee_by: contract.transfer_fee_by,
            sign_seller: contract.sign_seller,
            sign_buyer: contract.sign_buyer,
            sign_witness1: contract.sign_witness1,
            sign_witness2: contract.sign_witness2,
            car_cost: contract.car_buy_cost,
            cash_pledge: contract.cash_pledge,
            paid_due_date: paid_due_date,
            pay_method: contract.pay_method,
            car_id: contract.car_id,
            card_code: contract.card_code,
            card_out_at: contract.card_out_at,
            card_out_date: contract.card_out_date,
            card_type: contract.card_type,
            contract_note: contract.contract_note,
            contract_type: contract.contract_type,
          });
        }
      })
      .catch((err) => {
        console.log("err: ", err);
      });
  }

  async loadCarById() {
    const { contract_id } = this.state;

    if (contract_id !== null) {
      return;
    }

    await axios
      .get(APIURL + "/car/" + this.state.car_id)
      .then((res) => {
        let car = res.data[0];

        let seller_name =
          car.car_name_owner_old + " " + car.car_lastname_owner_old;
        let seller_mobile = car.car_telephone_old;
        let seller_address = car.car_address_old;
        let card_code = car.car_id_card;

        let car_name = "";
        let car_license_plate =
          car.car_license_plate_new !== "" &&
          car.car_license_plate_new !== car.car_license_plate_old
            ? car.car_license_plate_new
            : car.car_license_plate_old;
        let province_name =
          car.car_license_plate_new !== "" &&
          car.car_license_plate_new !== car.car_license_plate_old
            ? car.province_name_new
            : car.province_name_old;
        let car_num_engines = car.car_num_engines; // เลขเครื่องยนต์
        let car_number = car.car_number; // เลขตัวรถ
        let car_year_name = car.car_year_name; // ปี
        let car_color_name = car.car_color_name; // สี
        let car_gear_name = car.car_gear_name; // เกียร์
        let car_structure_name = car.car_structure_name; // ลักษณะรถ

        let car_brand_name = car.car_brand_name;
        let car_model_name = car.car_model_name;
        let car_sub_model_name = car.car_sub_model_name;

        if (car_sub_model_name.indexOf(car_model_name) !== -1) {
          car_name = car_brand_name + " " + car_sub_model_name;
        } else {
          car_name =
            car_brand_name + " " + car_model_name + " " + car_sub_model_name;
        }

        let vat_buy = car.vat_buy;

        let car_cost = car.car_cost;
        if (vat_buy > 0) {
          car_cost = car_cost + vat_buy;
        }

        this.setState({
          car: car,
          seller_name: seller_name,
          seller_mobile: seller_mobile,
          seller_address: seller_address,
          card_code: card_code,
          //
          car_name,
          car_brand_name,
          car_model_name,
          car_license_plate,
          car_num_engines,
          car_number,
          car_year_name,
          car_color_name,
          province_name,
          car_cost,
          car_gear_name,
          car_structure_name,
        });
      })
      .catch((error) => {
        // alert("error"+error)
        this.setState({ car: {} });
      });
  }

  handleDateContract(date) {
    // let contract_date =  moment(date).format('YYYY-MM-DD')
    let contract_date = format(date, "yyyy-MM-dd");
    let contract_date_thai = DateUtil.convertLongDateThai(contract_date);

    // console.log(date)

    this.setState({
      startDateContract: date,
      isOpenDateContract: false,
      contract_date: date,
      contract_date_thai: contract_date_thai,
    });
  }

  handlePaidDueDate(date) {
    let paid_due_date = moment(date).format("YYYY-MM-DD");
    let paid_due_date_thai = DateUtil.convertLongDateThai(paid_due_date);

    this.setState({
      startPaidDueDate: date,
      isOpenPaidDueDate: false,
      paid_due_date: paid_due_date,
      paid_due_date_thai: paid_due_date_thai,
    });
  }

  handleOnChange(e) {
    let name = e.target.name;
    let val = e.target.value;

    this.setState({
      [name]: val,
    });
  }

  calOutstanding() {
    let car_cost = this.state.car_cost;
    let cash_pledge = this.state.cash_pledge;
    let remain_amount = Number(car_cost) - Number(cash_pledge);

    this.setState({
      remain_amount: remain_amount,
    });
  }

  loadDataCarSellPay(car_sell, car_id, customer_id) {
    if (car_id === "" || customer_id === "") {
      return;
    }

    axios
      .get(APIURL + "/car_sell_pay/buy/" + car_id + "/" + customer_id)
      .then((res) => {
        let car_sell_pay_list = res.data;
        let sum_pay = car_sell_pay_list.reduce(
          (acc, pay) => acc + pay.car_sell_pay_count,
          0
        );

        let real_sell_price = this.state.real_sell_price;
        let outstanding = Number(real_sell_price) - sum_pay;

        this.setState({
          cash_pledge: sum_pay,
          outstanding: outstanding,
        });
      })
      .catch((error) => {
        console.log("error:", error);
      });
  }

  saveCarContract(action) {
    let contract_no = this.state.contract_no;
    let write_at = this.state.write_at;
    let contract_date = this.state.contract_date;
    let contract_date_thai = this.state.contract_date_thai;

    let seller_name = this.state.seller_name;
    let seller_age = this.state.seller_age;
    let seller_mobile = this.state.seller_mobile;
    let seller_address = this.state.seller_address;
    let seller_nationality = this.state.seller_nationality;
    let seller_by = this.state.seller_by;

    let buyer_name = this.state.buyer_name;
    let buyer_age = this.state.buyer_age;
    let buyer_nationality = this.state.buyer_nationality;
    let buyer_address = this.state.buyer_address;
    let buyer_mobile = this.state.buyer_mobile;
    let buyer_by = this.state.buyer_by;

    let car_name = this.state.car_name;
    let car_license_plate = this.state.car_license_plate;
    let car_num_engines = this.state.car_num_engines;
    let car_number = this.state.car_number;
    let car_year_name = this.state.car_year_name;
    let car_color_name = this.state.car_color_name;
    let car_structure_name = this.state.car_structure_name;
    let car_brand_name = this.state.car_brand_name;
    let car_model_name = this.state.car_model_name;
    let car_gear_name = this.state.car_gear_name;

    let buy_sell_agreement1 = this.state.buy_sell_agreement1;
    let buy_sell_agreement2 = this.state.buy_sell_agreement2;
    let transfer_fee_by = this.state.transfer_fee_by;

    let sign_seller = this.state.sign_seller;
    let sign_buyer = this.state.sign_buyer;
    let sign_witness1 = this.state.sign_witness1;
    let sign_witness2 = this.state.sign_witness2;

    let paid_due_date = this.state.paid_due_date;
    let paid_due_date_thai = this.state.paid_due_date_thai;

    let car_id = this.state.car_id;
    let car_buy_cost = this.state.car_cost;
    let cash_pledge = this.state.cash_pledge;
    let pay_method = this.state.pay_method; // โดยชำระเป็น

    let card_type = this.state.card_type;
    let card_code = this.state.card_code;
    let card_out_at = this.state.card_out_at;
    let contract_note = this.state.contract_note; // หมายเหตุ
    let contract_type = "buy"; // sell, buy
    let card_out_date = this.state.card_out_date;

    if (write_at === "") {
      AlertWarning("กรอกสัญญาฉบับนี้ทำขึ้น ณ");
      return;
    }

    if (contract_date_thai === null) {
      AlertWarning("เลือกวันที่ทำสัญญา");
      return;
    }

    if (paid_due_date_thai === null) {
      AlertWarning("เลือกวันที่ครบกำหนดชำระ");
      return;
    }

    let username = this.state.user.user;

    let data = {
      contract_no: contract_no,
      write_at: write_at,
      contract_date: contract_date,
      seller_name: seller_name,
      seller_age: seller_age,
      seller_mobile: seller_mobile,
      seller_address: seller_address,
      seller_nationality: seller_nationality,
      seller_by: seller_by,
      buyer_name: buyer_name,
      buyer_age: buyer_age,
      buyer_nationality: buyer_nationality,
      buyer_address: buyer_address,
      buyer_mobile: buyer_mobile,
      buyer_by: buyer_by,
      car_name: car_name,
      car_license_plate: car_license_plate,
      car_num_engines: car_num_engines,
      car_number: car_number,
      car_year_name: car_year_name,
      car_color_name: car_color_name,
      car_structure_name: car_structure_name,
      car_brand_name: car_brand_name,
      car_model_name: car_model_name,
      car_gear_name: car_gear_name,
      buy_sell_agreement1: buy_sell_agreement1,
      buy_sell_agreement2: buy_sell_agreement2,
      transfer_fee_by: transfer_fee_by,
      sign_seller: sign_seller,
      sign_buyer: sign_buyer,
      sign_witness1: sign_witness1,
      sign_witness2: sign_witness2,
      card_type: card_type,
      card_code: card_code,
      card_out_at: card_out_at,
      cash_pledge: cash_pledge,
      paid_due_date: paid_due_date,
      car_id: car_id,
      contract_type: contract_type,
      car_buy_cost,
      pay_method,
      contract_note,
      username,
      card_out_date,
    };
    //console.log('data_contract==', data)
    //return;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        if (action === "add") {
          let url = APIURL + "/buy_contract";
          axios
            .post(url, data)
            .then((res) => {
              if (res.status === 200) {
                let resData = res.data;
                let contract_id = resData.contract_id;

                AlertSuccess("บันทึกข้อมูลเรียบร้อยแล้ว");
                this.setState(
                  {
                    isLoading: false,
                    contract_id: contract_id,
                    // isExist: true,
                  },
                  () => this.loadCarBuyContract()
                );
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        } else if (action === "edit") {
          let contract_id = this.state.contract_id;
          let editData = { ...data, contract_id: contract_id };
          let url = APIURL + "/buy_contract";

          axios
            .put(url, editData)
            .then((res) => {
              if (res.data === "success") {
                AlertSuccess("แก้ไขข้อมูลเรียบร้อยแล้ว");
                this.setState(
                  {
                    isLoading: false,
                  },
                  () => this.loadCarBuyContract()
                );
              }
            })
            .catch((error) => {
              console.log("error:", error);
            });
        }
      }
    );
  }

  printCarContract() {
    let contract = this.state.contract;
    let write_at = contract.write_at;
    let seller_name = contract.seller_name;
    let seller_age = contract.seller_age;
    let seller_mobile = contract.seller_mobile;
    let seller_address = contract.seller_address;
    let seller_nationality = contract.seller_nationality;
    let seller_by = contract.seller_by;

    let buyer_name = contract.buyer_name;
    let buyer_age = contract.buyer_age;
    let buyer_nationality = contract.buyer_nationality;
    let buyer_address = contract.buyer_address;
    let buyer_mobile = contract.buyer_mobile;
    let buyer_by = contract.buyer_by;

    let car_name = contract.car_name;
    let car_license_plate = contract.car_license_plate;
    let province_name = this.state.province_name;
    let car_num_engines = contract.car_num_engines;
    let car_number = contract.car_number;
    let car_year_name = contract.car_year_name;
    let car_color_name = contract.car_color_name;
    let car_structure_name = contract.car_structure_name;
    let car_brand_name = contract.car_brand_name;
    let car_model_name = contract.car_model_name;
    let car_gear_name = contract.car_gear_name;

    let buy_sell_agreement1 = contract.buy_sell_agreement1;
    let buy_sell_agreement2 = contract.buy_sell_agreement2;
    let transfer_fee_by = contract.transfer_fee_by;

    let sign_seller =
      contract.sign_seller === "" || contract.sign_seller === null
        ? "(....................................................................)"
        : "( " + contract.sign_seller + " )";
    let sign_buyer =
      contract.sign_buyer === "" || contract.sign_buyer === null
        ? "(....................................................................)"
        : "( " + contract.sign_buyer + " )";
    let sign_witness1 =
      contract.sign_witness1 === "" || contract.sign_witness1 === null
        ? "(....................................................................)"
        : "( " + contract.sign_witness1 + " )";
    let sign_witness2 =
      contract.sign_witness2 === "" || contract.sign_witness2 === null
        ? "(....................................................................)"
        : "( " + contract.sign_witness2 + " )";

    let card_type = contract.card_type;
    let card_code = contract.card_code;
    let card_out_at = contract.card_out_at;
    let cash_pledge = contract.cash_pledge;
    let car_buy_cost = contract.car_buy_cost;
    let pay_method = contract.pay_method;
    let card_out_date = contract.card_out_date; // fill text
    //
    let contract_date_thai = this.state.contract_date_thai;
    let paid_due_date_thai = this.state.paid_due_date_thai;
    let outstanding = Number(car_buy_cost) - Number(cash_pledge);

    let write_at_pad = stringUtil.addSpacePaddingFill(write_at, 56);

    let seller_name_pad = stringUtil.addSpacePaddingFill(seller_name, 60);
    let seller_age_pad = stringUtil.addSpacePaddingFill(seller_age, 12);
    let seller_address_pad = stringUtil.addSpacePaddingFill(seller_address, 96);
    let seller_mobile_pad = stringUtil.addSpacePaddingFill(seller_mobile, 50);
    let seller_nationality_pad = stringUtil.addSpacePaddingFill(
      seller_nationality,
      22
    );
    let seller_by_pad = stringUtil.addSpacePaddingFill(seller_by, 50);

    let buyer_name_pad = stringUtil.addSpacePaddingFill(buyer_name, 60);
    let buyer_age_pad = stringUtil.addSpacePaddingFill(buyer_age, 12);
    let buyer_address_pad = stringUtil.addSpacePaddingFill(buyer_address, 90);
    let buyer_mobile_pad = stringUtil.addSpacePaddingFill(buyer_mobile, 50);
    let buyer_nationality_pad = stringUtil.addSpacePaddingFill(
      buyer_nationality,
      22
    );
    let buyer_by_pad = stringUtil.addSpacePaddingFill(buyer_by, 50);

    let car_license_pad = stringUtil.addSpacePaddingFill(car_license_plate, 44);
    let province_name_pad = stringUtil.addSpacePaddingFill(province_name, 24);
    let car_num_engines_pad = stringUtil.addSpacePaddingFill(
      car_num_engines,
      42
    );
    let car_number_pad = stringUtil.addSpacePaddingFill(car_number, 26);
    let car_year_name_pad = stringUtil.addSpacePaddingFill(car_year_name, 12);
    let car_color_name_pad = stringUtil.addSpacePaddingFill(car_color_name, 22);
    let car_structure_name_pad = stringUtil.addSpacePaddingFill(
      car_structure_name,
      54
    );
    let car_brand_name_pad = stringUtil.addSpacePaddingFill(car_brand_name, 26);
    let car_model_name_pad = stringUtil.addSpacePaddingFill(car_model_name, 26);
    let car_gear_name_pad = stringUtil.addSpacePaddingFill(car_gear_name, 16);

    let buy_sell_agreement1_pad = stringUtil.addSpacePaddingFill(
      buy_sell_agreement1,
      62
    );
    let buy_sell_agreement2_pad = stringUtil.addSpacePaddingFill(
      buy_sell_agreement2,
      90
    );
    let transfer_fee_by_pad = stringUtil.addSpacePaddingFill(
      transfer_fee_by,
      14
    );

    let car_buy_cost_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(car_buy_cost, 10)),
      24
    );
    let cash_pledge_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(cash_pledge, 10)),
      24
    );
    let outstanding_pad = stringUtil.addSpacePaddingFill(
      NumberUtil.addCommas(parseInt(outstanding, 10)),
      24
    );

    let paid_due_date_thai_pad = stringUtil.addSpacePaddingFill(
      paid_due_date_thai,
      28
    );
    let contract_date_thai_pad = stringUtil.addSpacePaddingFill(
      contract_date_thai,
      28
    );

    const pageBreak = {
      text: "",
      style: "contentCenterBold",
      pageBreak: "before",
      pageOrientation: "portrait",
    };

    let docDefinition = {
      pageOrientation: "portrait",
      pageSize: "A4",
      pageMargins: [48, 35, 40, 0],
      content: [
        {
          columns: [{ width: "100%", style: "normal", text: "" }],
          columnGap: 0,
          lineHeight: 1.5,
        },
        {
          table: {
            widths: ["30%", "40%", "30%"],
            body: [
              [
                { text: "", style: "normal" },
                {
                  text: "สัญญาซื้อรถเข้า",
                  style: "bodyhead",
                  margin: [0, 10, 0, 20],
                },
                { text: "", style: "normal" },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "22%", style: "normal", text: "สัญญาฉบับนี้ทำขึ้น ณ " },
            {
              width: "41%",
              style: ["normal", "bottomLine"],
              text: write_at_pad,
            },
            { width: "7%", style: "normal", text: "วันที่ " },
            {
              width: "30%",
              style: ["normalLeft", "bottomLine"],
              text: contract_date_thai_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "10%", style: "normal", text: "ระหว่าง" },
            {
              width: "48%",
              style: ["normal", "bottomLine"],
              text: seller_name_pad,
            },
            { width: "6%", style: "normal", text: "อายุ" },
            {
              width: "5%",
              style: ["normal", "bottomLine"],
              text: seller_age_pad,
            },
            { width: "2%", style: "normal", text: "ปี" },
            { width: "10%", style: "normal", text: "สัญชาติ" },
            {
              width: "30%",
              style: ["normalLeft", "bottomLine"],
              text: seller_nationality_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "25%",
              style: "normal",
              text: "ที่อยู่ / ที่ตั้งสำนักงาน เลขที่",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: seller_address_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "10%", style: "normal", text: "โทรศัพท์" },
            {
              width: "40%",
              style: ["normal", "bottomLine"],
              text: seller_mobile_pad,
            },
            { width: "7%", style: "normal", text: "โดย" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: seller_by_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "18%", style: "normalbold", text: "ผู้มีอำนาจกระทำแทน" },
            {
              width: "*",
              style: ["normal"],
              text: ' ปรากฏตามเอกสารแนบท้าย ซึ่งต่อไปในสัญญานี้เรียกว่า "ผู้จะขาย" ฝ่ายหนึ่ง',
            },
          ],
          columnGap: 10,
          margin: [0, 5, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "10%", style: "normal", text: "กับ" },
            {
              width: "48%",
              style: ["normal", "bottomLine"],
              text: buyer_name_pad,
            },
            { width: "6%", style: "normal", text: "อายุ" },
            {
              width: "5%",
              style: ["normal", "bottomLine"],
              text: buyer_age_pad,
            },
            { width: "2%", style: "normal", text: "ปี" },
            { width: "10%", style: "normal", text: "สัญชาติ" },
            {
              width: "30%",
              style: ["normalLeft", "bottomLine"],
              text: buyer_nationality_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "25%",
              style: "normal",
              text: "ที่อยู่ / ที่ตั้งสำนักงาน เลขที่",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: buyer_address_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "10%", style: "normal", text: "โทรศัพท์" },
            {
              width: "40%",
              style: ["normal", "bottomLine"],
              text: buyer_mobile_pad,
            },
            { width: "7%", style: "normal", text: "โดย" },
            { width: "*", style: ["normal", "bottomLine"], text: buyer_by_pad },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "14%", style: "normalbold", text: "ผู้กระทำการแทน" },
            {
              width: "*",
              style: ["normal"],
              text: ' ซึ่งต่อไปในสัญญานี้เรียกว่า "ผู้จะซื้อ" ฝ่ายหนึ่ง',
            },
          ],
          columnGap: 10,
          margin: [0, 5, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normalbold",
              text: "คู่สัญญาทั้งสองฝ่ายตกลงทำสัญญากันโดยมีข้อความดังต่อไปนี้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 1 คำรับรองของผู้จะขาย" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "48%",
              style: "normal",
              text: "ผู้จะขายรับรองว่าผู้จะขายเป็นผู้ถือกรรมสิทธิ์รถ ประเภท",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_structure_name_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "7%", style: "normal", text: "ยี่ห้อ" },
            {
              width: "18%",
              style: ["normal", "bottomLine"],
              text: car_brand_name_pad,
            },
            { width: "6%", style: "normal", text: "รุ่น" },
            {
              width: "18%",
              style: ["normal", "bottomLine"],
              text: car_model_name_pad,
            },
            { width: "4%", style: "normal", text: "ปี" },
            {
              width: "7%",
              style: ["normal", "bottomLine"],
              text: car_year_name_pad,
            },
            { width: "7%", style: "normal", text: "เกียร์" },
            {
              width: "11%",
              style: ["normal", "bottomLine"],
              text: car_gear_name_pad,
            },
            { width: "4%", style: "normal", text: "สี" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_color_name_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "18%", style: "normal", text: "หมายเลขทะเบียน" },
            {
              width: "12%",
              style: ["normal", "bottomLine"],
              text: car_license_pad,
            },
            { width: "18%", style: ["normal"], text: province_name_pad },
            { width: "16%", style: "normal", text: "หมายเลขเครื่อง" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: car_num_engines_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: "20%", style: "normal", text: "หมายเลขตัวถังรถยนต์" },
            {
              width: "23%",
              style: ["normal", "bottomLine"],
              text: car_number_pad,
            },
            {
              width: "*",
              style: ["normal"],
              text: "ทั้งนี้ รายละเอียดของรถยนต์ปรากฏตามสมุดคู่มือทะเบียนรถยนต์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: ["normal"],
              text: "แนบท้ายสัญญา และถือเป็นส่วนหนึ่งของสัญญานี้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 2 ข้อตกลงจะซื้อจะขาย" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ผู้จะขายตกลงจะขายและผู้จะซื้อตกลงจะซื้อ รถ ตามข้อ 1 ข้างต้น ในสัญญานี้ ซึ่งเป็นกรรมสิทธิ์และสิทธิครอบครอง",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "53%",
              style: "normal",
              text: "ของผู้จะขาย ไม่มีจำนำกับผู้อื่นใด และ/หรือ มีสัญญาเช่าซื้อไว้กับ",
            },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: buy_sell_agreement1_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "30%",
              style: "normal",
              text: "โดยมีข้อตกลงท้ายสัญญาเช่าความว่า",
            },
            {
              width: "70%",
              style: ["normal", "bottomLine"],
              text: buy_sell_agreement2_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 3 . ราคาจะซื้อจะขาย" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "56%",
              style: "normal",
              text: "ผู้จะซื้อและผู้จะขายตกลงจะซื้อจะขาย รถ ตามสัญญานี้ ในราคา ",
            },
            {
              width: "16%",
              style: ["normal", "bottomLine"],
              text: car_buy_cost_pad,
            },
            { width: "*", style: "normal", text: "บาท" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: "(" + ThaiBaht(car_buy_cost) + ")",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ข้อ 4 . การชำระเงินและการโอนกรรมสิทธิ์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "80%",
              style: "normal",
              text: "4.1 คู่สัญญาตกลงให้ผู้จะซื้อได้ชำระเงินจอง/เงินวางมัดจำ ณ วันที่ทำสัญญาฉบับนี้ เป็นจำนวนเงิน ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "16%",
              style: ["normal", "bottomLine"],
              text: cash_pledge_pad,
            },
            { width: "5%", style: "normal", text: "บาท" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: "(" + ThaiBaht(cash_pledge) + ")",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "42%",
              style: "normal",
              text: "4.2 ผู้จะซื้อตกลงชำระราคารถ ที่เหลือ จำนวน ",
            },
            {
              width: "16%",
              style: ["normal", "bottomLine"],
              text: outstanding_pad,
            },
            { width: "5%", style: "normal", text: "บาท" },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: "(" + ThaiBaht(outstanding) + ")",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            { width: "18%", style: "normal", text: "ชำระภายในวันที่ " },
            {
              width: "*",
              style: ["normal", "bottomLine"],
              text: paid_due_date_thai_pad,
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        pageBreak,

        {
          table: {
            widths: ["30%", "40%", "30%"],
            body: [
              [
                { text: "", style: "normal" },
                {
                  text: "2",
                  style: ["normalCenter"],
                  margin: [0, 10, 0, 20],
                },
                { text: "", style: "normal" },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ข้อ 5 การจดทะเบียนโอนกรรมสิทธิ์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ในการจดทะเบียนโอนกรรมสิทธิ์รถ ตามสัญญานี้ให้ผู้จะซื้อ เมื่อการชำระเงินค่ารถตามสัญญานี้ครบถ้วนแล้ว",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ผู้จะขายต้องทำหนังสือสัญญาซื้อขายร่วมกันขึ้นอีก 1 ฉบับ หรือจัดทำหนังสือมอบอำนาจพร้อมชุดโอนและรับโอนกรรมสิทธิ์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "รถให้กับผู้จะซื้อหรือผู้รับมอบอำนาจ ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ข้อ 6 ค่าใช้จ่ายในการจดทะเบียนโอนกรรมสิทธิ์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ค่าธรรมเนียมและค่าใช้จ่ายในการดำเนินการโอนกรรมสิทธิ์ รวมทั้งค่าภาษีอากรในการจดทะเบียนโอนกรรมสิทธิ์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "27%",
              style: "normal",
              text: "หรือค่าใช้จ่ายอื่น ๆ (ถ้ามี)  ผู้จะ",
            },
            {
              width: "5%",
              style: ["normal", "bottomLine"],
              text: transfer_fee_by_pad,
            },
            { width: "*", style: "normal", text: "เป็นผู้ออกทั้งสิ้น" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 7 การก่อภาระผูกพัน" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ภายหลังการทำสัญญาจะซื้อจะขายรถตามสัญญานี้แล้ว ผู้จะขายต้องไม่กระทำการใด ๆ อันเป็นเหตุให้รถ ที่จะขายนั้น",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "เกิดภาระผูกพันเพิ่มขึ้นกับบุคคลที่สาม",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 8 การบอกเลิกสัญญา" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "หากผู้จะขายหรือผู้จะซื้อ ผิดสัญญาข้อหนึ่งข้อใด ผู้จะขายหรือผู้จะซื้อมีสิทธิบอกเลิกสัญญา และสามารถดำเนินการ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ตามสัญญาหรือฟ้องร้องคดีได้ทันที",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "ข้อ 9 สิทธิภายหลังการบอกเลิกสัญญา",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "9.1 เมื่อผู้จะขายผิดสัญญาข้อหนึ่งข้อใดแล้ว ผู้จะขายยินยอมให้ผู้จะซื้อเรียกเงินที่ผู้จะซื้อได้ชำระไปแล้วทั้งหมดคืนจากผู้จะขาย พร้อมดอกเบี้ยในอัตราร้อยละ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "15 ต่อปี นับแต่วันที่ผู้จะซื้อได้ชำระเงินไปรวมทั้งเรียกค่าเสียหายอื่นอันพึงมีพึงได้",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "9.2 เมื่อผู้จะซื้อผิดสัญญาข้อหนึ่งข้อใดแล้ว ผู้จะซื้อยินยอมให้ผู้จะขายหักเงินที่ผู้จะซื้อชำระไว้แล้วเป็นค่าเสียหายตามความเป็นจริง ทั้งนี้ค่าเสียหายดังกล่าว",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ต้องมีจำนวนไม่เกินเงินที่ผู้จะซื้อชำระไว้แล้วทั้งหมด ถ้ามีเงินเหลือหลังจากหักค่าเสียหายแล้วให้ผู้จะขายเป็นผู้พิจารณาคืนเงิน",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ให้แก่ผู้จะซื้อตามดุลยพินิจ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 10 คำบอกกล่าว" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "การบอกกล่าวใด ๆ ตามสัญญานี้ต้องทำเป็นหนังสือและแจ้งไปยังคู่สัญญาอีกฝ่ายหนึ่งตามที่อยู่ข้างต้น หรือที่อยู่อื่น",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ตามที่คู่สัญญาฝ่ายใดฝ่ายหนึ่งจะได้แจ้งเป็นหนังสือให้อีกฝ่ายหนึ่งทราบ หากเป็นการแจ้งทางไปรษณีย์ให้ส่งโดยไปรษณีย์",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: "ลงทะเบียนตอบรับและให้ถือว่าคู่สัญญาฝ่ายที่รับแจ้งได้รับแจ้งตั้งแต่วันที่ได้รับหนังสือดังกล่าว",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        pageBreak,
        {
          table: {
            widths: ["30%", "40%", "30%"],
            body: [
              [
                { text: "", style: "normal" },
                {
                  text: "3",
                  style: ["normalCenter"],
                  margin: [0, 10, 0, 20],
                },
                { text: "", style: "normal" },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normalbold",
              text: "เมื่อคู่สัญญาฝ่ายใดย้ายที่อยู่ต้องแจ้งให้อีกฝ่ายหนึ่งทราบเป็นหนังสือ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            { width: "*", style: "normal", text: "ข้อ 11  เอกสารแนบท้ายสัญญา" },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 40, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "คู่สัญญาตกลงให้ถือว่าเอกสารต่าง ๆ แนบท้ายสัญญาซึ่งคู่สัญญาได้ลงนามกำกับไว้ด้วย",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            { width: 15, style: "normal", text: " " },
            {
              width: "*",
              style: "normal",
              text: "สัญญานี้ทำขึ้นเป็นสองฉบับมีข้อความถูกต้องตรงกัน คู่สัญญาได้อ่านและเข้าใจข้อความในสัญญาโดยตลอดดีแล้ว",
            },
          ],
          columnGap: 10,
          margin: [0, 30, 0, 3],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "*",
              style: "normal",
              text: " จึงลงลายมือชื่อพร้อมทั้งประทับตรา (ถ้ามี) ไว้เป็นสำคัญต่อหน้าพยาน และเก็บไว้ฝ่ายละหนึ่งฉบับ",
            },
          ],
          columnGap: 10,
          margin: [0, 0, 0, 5],
          lineHeight: 1,
        },
        {
          columns: [
            {
              width: "45%",
              style: "normal",
              text: "ลงชื่อ....................................................................(ผู้จะขาย)",
            },
            { width: "10%", style: "normal", text: " " },
            {
              width: "45%",
              style: "normal",
              text: "ลงชื่อ....................................................................(ผู้จะซื้อ)",
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 50, 0, 0],
        },
        {
          columns: [
            {
              width: "45%",
              style: "normalCenter",
              margin: [0, 0, 10, 10],
              text: sign_seller,
            },
            { width: "10%", style: "normal", text: " " },
            {
              width: "45%",
              margin: [0, 0, 10, 10],
              style: "normalCenter",
              text: sign_buyer,
            },
          ],
        },

        {
          columns: [
            {
              width: "45%",
              style: "normal",
              text: "ลงชื่อ....................................................................(พยาน)",
            },
            { width: "10%", style: "normal", text: " " },
            {
              width: "45%",
              style: "normal",
              text: "ลงชื่อ....................................................................(พยาน)",
            },
          ],
          columnGap: 0,
          lineHeight: 1,
          margin: [0, 12, 0, 0],
        },
        {
          columns: [
            {
              width: "45%",
              style: "normalCenter",
              margin: [0, 0, 10, 10],
              text: sign_witness1,
            },
            { width: "10%", style: "normal", text: " " },
            {
              width: "45%",
              margin: [0, 0, 10, 10],
              style: "normalCenter",
              text: sign_witness2,
            },
          ],
        },
      ],
      styles: {
        bodyhead: {
          fontSize: 16,
          bold: true,
          alignment: "center",
        },
        normal: {
          fontSize: 15,
        },
        normalbold: {
          fontSize: 15,
          bold: true,
        },
        normalRight: {
          fontSize: 15,
          alignment: "right",
        },
        normalLeft: {
          fontSize: 15,
          alignment: "left",
        },
        normalCenter: {
          fontSize: 15,
          alignment: "center",
        },
        textBold: {
          fontSize: 15,
          bold: true,
        },
        textLargeBold: {
          fontSize: 18,
          bold: true,
          alignment: "center",
        },
        bottomLine: {
          decoration: "underline",
          decorationStyle: "dotted",
        },
      },
      defaultStyle: {
        font: "THSarabunNew",
      },
    };
    pdfMake.createPdf(docDefinition).open();
  }

  render() {
    return (
      <div className="row">
        <Loading isLoading={this.state.isLoading} />

        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <strong className="text-title">สัญญาซื้อรถเข้า</strong>
            </div>

            <div
              className="card-block"
              style={{ paddingLeft: 80, paddingRight: 80, paddingTop: 10 }}
            >
              <div className="row" style={{ lineHeight: 2.0 }}>
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td width={"30%"} style={styles.tdContentCenter}>
                        &nbsp;
                      </td>
                      <td style={styles.tdContentCenter}>
                        <strong className="text-title" style={{ fontSize: 16 }}>
                          สัญญาซื้อรถเข้า
                        </strong>
                      </td>
                      <td width={"30%"}>&nbsp;</td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-5 ml-5 mb-2">
                          <span>สัญญาฉบับนี้ทำขึ้น ณ </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputDataWriteAt}
                            value={this.state.write_at}
                            onChange={(e) => {
                              this.setState({
                                write_at: e.target.value,
                              });
                            }}
                          />

                          <span className="mr-3">วันที่</span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 180 }}
                            value={
                              this.state.contract_date_thai === null
                                ? ""
                                : this.state.contract_date_thai
                            }
                          />

                          <div>
                            {/*<DatePickerBuddhist
                              selected={this.state.startDateContract}
                              onChange={this.handleDateContract}
                              dateFormat="yyyy-MM-dd"
                          />*/}
                            {/*<DatePicker
                               selected={this.state.startDateContract}
                               value={this.state.contract_date_thai === null ? '' : this.state.contract_date_thai}
                               onChange={this.handleDateContract}
                               dateFormat="yyyy-MM-dd"
                               customInput={<DatePickerIcon/>}
                          />*/}

                            <ThaiDatePicker
                              value={this.state.startDateContract}
                              onChange={this.handleDateContract}
                              dateFormat="yyyy-MM-dd"
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    {/*{ผู้ขาย}*/}
                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>ระหว่าง</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="seller_name"
                            value={this.state.seller_name}
                            onChange={this.handleOnChange}
                          />
                          <span>อายุ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="seller_age"
                            value={this.state.seller_age}
                            onChange={this.handleOnChange}
                            inputMode={"numeric"}
                            maxLength={2}
                          />
                          &nbsp;ปี &nbsp;&nbsp;&nbsp;
                          <span>สัญชาติ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="seller_nationality"
                            value={this.state.seller_nationality}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>ที่อยู่ / ที่ตั้งสำนักงาน เลขที่</span>
                          <input
                            className="form-control ml-2"
                            style={{ width: "600px", borderRadius: "5px" }}
                            name="seller_address"
                            value={this.state.seller_address}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>โทรศัพท์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="seller_mobile"
                            value={this.state.seller_mobile}
                            onChange={this.handleOnChange}
                          />

                          <span>โดย</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="seller_by"
                            value={this.state.seller_by}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>
                            <strong>ผู้มีอำนาจกระทำแทน</strong>{" "}
                            ปรากฏตามเอกสารแนบท้าย ซึ่งต่อไปในสัญญานี้เรียกว่า
                            "ผู้จะขาย" ฝ่ายหนึ่ง
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>กับ</span>
                          <input
                            className="form-control ml-5 mr-3"
                            style={styles.inputLong}
                            name="buyer_name"
                            value={this.state.buyer_name}
                            onChange={this.handleOnChange}
                          />
                          <span>อายุ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="buyer_age"
                            value={this.state.buyer_age}
                            onChange={this.handleOnChange}
                            inputMode={"numeric"}
                            maxLength={2}
                          />
                          &nbsp;ปี &nbsp;&nbsp;&nbsp;
                          <span>สัญชาติ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="buyer_nationality"
                            value={this.state.buyer_nationality}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>ที่อยู่ / ที่ตั้งสำนักงาน เลขที่</span>
                          <input
                            className="form-control ml-2"
                            style={{ width: "600px", borderRadius: "5px" }}
                            name="buyer_address"
                            value={this.state.buyer_address}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>โทรศัพท์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="buyer_mobile"
                            value={this.state.buyer_mobile}
                            onChange={this.handleOnChange}
                          />

                          <span>โดย</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputLong}
                            name="buyer_by"
                            value={this.state.buyer_by}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2">
                          <span>
                            <strong>ผู้กระทำการแทน</strong>{" "}
                            ซึ่งต่อไปในสัญญานี้เรียกว่า "ผู้จะซื้อ" ฝ่ายหนึ่ง
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-2 ml-5">
                          <strong>
                            คู่สัญญาทั้งสองฝ่ายตกลงทำสัญญากันโดยมีข้อความดังต่อไปนี้
                          </strong>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 1 คำรับรองของผู้จะขาย</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>
                            ผู้จะขายรับรองว่าผู้จะขายเป็นผู้ถือกรรมสิทธิ์รถ
                            ประเภท
                          </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={{ width: "380px", borderRadius: "5px" }}
                            name="car_structure_name"
                            value={this.state.car_structure_name}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>ยี่ห้อ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_brand_name"
                            value={this.state.car_brand_name}
                            onChange={this.handleOnChange}
                          />

                          <span>รุ่น</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_model_name"
                            value={this.state.car_model_name}
                            onChange={this.handleOnChange}
                          />

                          <span>ปี</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_year_name"
                            value={this.state.car_year_name}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>เกียร์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_gear_name"
                            value={this.state.car_gear_name}
                            onChange={this.handleOnChange}
                          />

                          <span>สี</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_color_name"
                            value={this.state.car_color_name}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>หมายเลขทะเบียน</span>
                          <input
                            className="form-control ml-3 mr-1"
                            style={styles.inputMedium}
                            name="car_license_plate"
                            value={this.state.car_license_plate}
                            onChange={this.handleOnChange}
                          />

                          <input
                            className="form-control ml-2 mr-3"
                            style={{ borderRadius: "5px", width: "130px" }}
                            name="province_name"
                            disabled
                            value={this.state.province_name}
                            //onChange={this.handleOnChange}
                          />

                          <span>หมายเลขเครื่อง</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_num_engines"
                            value={this.state.car_num_engines}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3">
                          <span>หมายเลขตัวถังรถยนต์</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputMedium}
                            name="car_number"
                            value={this.state.car_number}
                            onChange={this.handleOnChange}
                          />

                          <span>
                            ทั้งนี้
                            รายละเอียดของรถยนต์ปรากฏตามสมุดคู่มือทะเบียนรถยนต์
                            แนบท้ายสัญญา และถือเป็นส่วนหนึ่งของสัญญานี้
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 2 ข้อตกลงจะซื้อจะขาย</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>
                            ผู้จะขายตกลงจะขายและผู้จะซื้อตกลงจะซื้อ รถ ตามข้อ 1
                            ข้างต้น ในสัญญานี้
                            ซึ่งเป็นกรรมสิทธิ์และสิทธิครอบครองของผู้จะขาย
                            ไม่มีจำนำกับผู้อื่นใด
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1">
                          <span>และ/หรือ มีสัญญาเช่าซื้อไว้กับ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={{ width: "570px", borderRadius: "5px" }}
                            name="buy_sell_agreement1"
                            value={this.state.buy_sell_agreement1}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3">
                          <span>โดยมีข้อตกลงท้ายสัญญาเช่าความว่า </span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={{ width: "535px", borderRadius: "5px" }}
                            name="buy_sell_agreement2"
                            value={this.state.buy_sell_agreement2}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 3 . ราคาจะซื้อจะขาย</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            ผู้จะซื้อและผู้จะขายตกลงจะซื้อจะขาย รถ ตามสัญญานี้
                            ในราคา{" "}
                          </span>
                          <NumberFormat
                            className="form-control ml-2"
                            style={styles.inputLong}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.car_cost}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ car_cost: value }, () =>
                                this.calOutstanding()
                              );
                            }}
                          />
                          <span style={{ width: 30 }} className="ml-2">
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.car_cost)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 4 . การชำระเงินและการโอนกรรมสิทธิ์</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>
                            4.1
                            คู่สัญญาตกลงให้ผู้จะซื้อได้ชำระเงินจอง/เงินวางมัดจำ
                            ณ วันที่ทำสัญญาฉบับนี้ เป็นจำนวนเงิน
                          </span>
                          <NumberFormat
                            className="form-control ml-2"
                            style={styles.inputLong}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.cash_pledge}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ cash_pledge: value }, () =>
                                this.calOutstanding()
                              );
                            }}
                          />
                          <span style={{ width: 30 }} className="ml-2">
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.cash_pledge)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>
                            4.2 ผู้จะซื้อตกลงชำระราคารถ ที่เหลือ จำนวน
                          </span>
                          <NumberFormat
                            className="form-control ml-2"
                            style={styles.inputLong}
                            thousandSeparator={true}
                            prefix={""}
                            placeholder=""
                            min={0}
                            max={1000000000}
                            step={1000}
                            size={10}
                            allowNegative={false}
                            value={this.state.remain_amount}
                            onValueChange={(values) => {
                              const { value } = values;
                              this.setState({ remain_amount: value }, () =>
                                this.calOutstanding()
                              );
                            }}
                          />
                          <span style={{ width: 30 }} className="ml-2">
                            {" "}
                            บาท
                          </span>
                          <span className="ml-1">
                            ({ThaiBaht(this.state.remain_amount)})
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span className="mr-3">ชำระภายในวันที่ </span>
                          <input
                            readOnly={true}
                            className="form-control"
                            style={{ width: 180 }}
                            value={
                              this.state.paid_due_date_thai === null
                                ? ""
                                : this.state.paid_due_date_thai
                            }
                          />

                          <div>
                            <ThaiDatePicker
                              value={this.state.startPaidDueDate}
                              onChange={this.handlePaidDueDate}
                              dateFormat="yyyy-MM-dd"
                              type={"icon"}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 5 การจดทะเบียนโอนกรรมสิทธิ์</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            ในการจดทะเบียนโอนกรรมสิทธิ์รถ
                            ตามสัญญานี้ให้ผู้จะซื้อ
                            เมื่อการชำระเงินค่ารถตามสัญญานี้ครบถ้วนแล้ว
                            ผู้จะขายต้องทำหนังสือสัญญาซื้อขายร่วมกันขึ้นอีก 1
                            ฉบับ
                            หรือจัดทำหนังสือมอบอำนาจพร้อมชุดโอนและรับโอนกรรมสิทธิ์รถให้กับผู้จะซื้อหรือผู้รับมอบอำนาจ
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>
                            ข้อ 6 ค่าใช้จ่ายในการจดทะเบียนโอนกรรมสิทธิ์
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            ค่าธรรมเนียมและค่าใช้จ่ายในการดำเนินการโอนกรรมสิทธิ์
                            รวมทั้งค่าภาษีอากรในการจดทะเบียนโอนกรรมสิทธิ์
                          </span>
                          <span> หรือค่าใช้จ่ายอื่น ๆ (ถ้ามี) ผู้จะ</span>
                          <input
                            className="form-control ml-3 mr-3"
                            style={styles.inputShort}
                            name="transfer_fee_by"
                            value={this.state.transfer_fee_by}
                            onChange={this.handleOnChange}
                          />
                          <span> เป็นผู้ออกทั้งสิ้น</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 7 การก่อภาระผูกพัน</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            ภายหลังการทำสัญญาจะซื้อจะขายรถตามสัญญานี้แล้ว
                            ผู้จะขายต้องไม่กระทำการใด ๆ อันเป็นเหตุให้รถ
                            ที่จะขายนั้นเกิดภาระผูกพันเพิ่มขึ้นกับบุคคลที่สาม
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 8 การบอกเลิกสัญญา</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            หากผู้จะขายหรือผู้จะซื้อ ผิดสัญญาข้อหนึ่งข้อใด
                            ผู้จะขายหรือผู้จะซื้อมีสิทธิบอกเลิกสัญญา
                            และสามารถดำเนินการตามสัญญาหรือฟ้องร้องคดีได้ทันที
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 9 สิทธิภายหลังการบอกเลิกสัญญา</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            9.1 เมื่อผู้จะขายผิดสัญญาข้อหนึ่งข้อใดแล้ว
                            ผู้จะขายยินยอมให้ผู้จะซื้อเรียกเงินที่ผู้จะซื้อได้ชำระไปแล้วทั้งหมดคืนจากผู้จะขายพร้อมดอกเบี้ยในอัตราร้อยละ
                            15 ต่อปี
                            นับแต่วันที่ผู้จะซื้อได้ชำระเงินไปรวมทั้งเรียกค่าเสียหายอื่นอันพึงมีพึงได้
                          </span>
                          <span>
                            9.2 เมื่อผู้จะซื้อผิดสัญญาข้อหนึ่งข้อใดแล้ว
                            ผู้จะซื้อยินยอมให้ผู้จะขายหักเงินที่ผู้จะซื้อชำระไว้แล้วเป็นค่าเสียหายตามความเป็นจริง
                            ทั้งนี้ค่าเสียหายดังกล่าวต้องมีจำนวนไม่เกินเงินที่ผู้จะซื้อชำระไว้แล้วทั้งหมด
                            ถ้ามีเงินเหลือหลังจากหักค่าเสียหายแล้วให้ผู้จะขายเป็นผู้พิจารณาคืนเงินให้แก่ผู้จะซื้อตามดุลยพินิจ
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 10 คำบอกกล่าว</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            การบอกกล่าวใด ๆ
                            ตามสัญญานี้ต้องทำเป็นหนังสือและแจ้งไปยังคู่สัญญาอีกฝ่ายหนึ่งตามที่อยู่ข้างต้น
                            หรือที่อยู่อื่นตามที่คู่สัญญาฝ่ายใดฝ่ายหนึ่งจะได้แจ้งเป็นหนังสือให้อีกฝ่ายหนึ่งทราบ
                            หาก
                            เป็นการแจ้งทางไปรษณีย์ให้ส่งโดยไปรษณีย์ลงทะเบียนตอบรับและให้ถือว่าคู่สัญญาฝ่ายที่รับแจ้งได้รับแจ้งตั้งแต่วันที่ได้รับหนังสือดังกล่าว
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <strong>
                            เมื่อคู่สัญญาฝ่ายใดย้ายที่อยู่ต้องแจ้งให้อีกฝ่ายหนึ่งทราบเป็นหนังสือ
                          </strong>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-1 ml-5">
                          <span>ข้อ 11 เอกสารแนบท้ายสัญญา</span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mb-3 ml-5">
                          <span>
                            คู่สัญญาตกลงให้ถือว่าเอกสารต่าง ๆ
                            แนบท้ายสัญญาซึ่งคู่สัญญาได้ลงนามกำกับไว้ด้วย
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-2 mb-3 ml-5">
                          <span>
                            สัญญานี้ทำขึ้นเป็นสองฉบับมีข้อความถูกต้องตรงกัน
                            คู่สัญญาได้อ่านและเข้าใจข้อความในสัญญาโดยตลอดดีแล้ว
                            จึงลงลายมือชื่อพร้อมทั้งประทับตรา (ถ้ามี)
                            ไว้เป็นสำคัญต่อหน้าพยาน และเก็บไว้ฝ่ายละหนึ่งฉบับ
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div className="form-inline mt-2 ml-5">
                          <span>
                            ลงชื่อ...............................................................................(ผู้จะขาย)
                          </span>
                        </div>
                      </td>

                      <td>
                        <div className="form-inline mt-2">
                          <span>
                            ลงชื่อ...............................................................................(ผู้จะซื้อ)
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div className="form-inline mt-1 ml-5">
                          <input
                            type="text"
                            style={styles.inputLong}
                            className="form-control mb-2"
                            name="sign_seller"
                            value={this.state.sign_seller}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>

                      <td>
                        <div className="form-inline mt-1">
                          <input
                            type="text"
                            style={styles.inputLong}
                            className="form-control mb-2"
                            name="sign_buyer"
                            value={this.state.sign_buyer}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div className="form-inline mt-3 ml-5">
                          <span>
                            ลงชื่อ...............................................................................(พยาน)
                          </span>
                        </div>
                      </td>

                      <td>
                        <div className="form-inline mt-3">
                          <span>
                            ลงชื่อ...............................................................................(พยาน)
                          </span>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <div className="form-inline mt-1 ml-5">
                          <input
                            type="text"
                            style={styles.inputLong}
                            className="form-control mb-2"
                            name="sign_witness1"
                            value={this.state.sign_witness1}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>

                      <td>
                        <div className="form-inline mt-1">
                          <input
                            type="text"
                            style={styles.inputLong}
                            className="form-control mb-2"
                            name="sign_witness2"
                            value={this.state.sign_witness2}
                            onChange={this.handleOnChange}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan={3}>
                        <div className="form-inline mt-3 mb-1 ml-5">
                          <span>
                            ข้อความใดไม่ใช้ให้ขีดฆ่าออกแล้วคู่สัญญาลงลายมือชื่อกำกับไว้ทุกแห่ง
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="col-md-12 text-right">
                <div className="card-block">
                  {this.manageAddEditButton()}
                  {this.managePrintButton()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  table: {
    width: "100%",
    maxWidth: "100%",
  },
  tdContentCenter: {
    textAlign: "center",
    verticalAlign: "middle",
  },
  tdContentRight: {
    textAlign: "right",
    verticalAlign: "middle",
    justifyContent: "right",
  },
  tdContentLeft: {
    textAlign: "left",
    verticalAlign: "middle",
  },
  tableTh: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
  },
  tableTdLeft: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "top",
  },
  tableTdCenter: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "left",
    verticalAlign: "middle",
    paddingLeft: "70px",
  },
  tableTdRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
  },
  tablePd: {
    paddingLeft: "50px",
    paddingRight: "50px",
    lineHeight: "2.2",
  },
  amountsText: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "center",
    verticalAlign: "middle",
    fontWeight: "bold",
  },
  amountsTextNoBorder: {
    maxWidth: "100%",
    textAlign: "center",
    verticalAlign: "middle",
  },
  amountsRigth: {
    maxWidth: "100%",
    borderColor: "#626262",
    borderWidth: "1px",
    borderStyle: "solid",
    textAlign: "right",
    verticalAlign: "top",
    fontWeight: "bold",
  },
  buttonHeight: {
    height: 32,
  },
  inputData: {
    borderRadius: "5px",
    width: "450px",
  },
  inputDataNum: {
    borderRadius: "5px",
    width: "100px",
  },
  inputDataWriteAt: {
    borderRadius: "5px",
    width: "280px",
  },
  inputShort: {
    borderRadius: "5px",
    width: "110px",
  },
  inputMedium: {
    borderRadius: "5px",
    width: "190px",
  },
  inputLong: {
    borderRadius: "5px",
    width: "320px",
  },
  iconCalendar: {
    width: "45px",
  },
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  token: state.auth.token,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(CarBuyContract2);
